import React from 'react';
import HeroSection from '../components/common/HeroSection';
import ContactForm from '../components/contact/ContactForm';
import LocationMap from '../components/contact/LocationMap';
import { Phone, Mail, MapPin } from 'lucide-react';

const Contact = () => {
  const contactInfo = [
    {
      icon: <Phone size={24} />,
      title: 'Call Us',
      content: (
        <a href="tel:+1-512-203-7627" className="text-blue-600 hover:text-blue-800 transition-colors">
          +1-512-203-7627
        </a>
      )
    },
    {
      icon: <Mail size={24} />,
      title: 'Email Us',
      content: (
        <a href="mailto:connect@tissatech.com" className="text-blue-600 hover:text-blue-800 transition-colors">
          connect@tissatech.com
        </a>
      )
    },
    {
      icon: <MapPin size={24} />,
      title: 'Visit Our Office',
      content: "2001 Timberloch Place, Suite 500 Woodlands, Houston, Texas 77380"
    }
  ];
  
  return (
    <div className="contact-page">
      <HeroSection 
        title="Contact Us"
        breadcrumb={[{ name: 'Contact Us' }]}
        background="/assets/images/contact-us.png"
      />
      
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            {contactInfo.map((item, index) => (
              <div 
                key={index} 
                className="bg-white p-8 rounded-lg shadow-md text-center"
              >
                <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 text-blue-600 rounded-full mb-6">
                  {item.icon}
                </div>
                <h3 className="text-xl font-bold mb-3">{item.title}</h3>
                <div className="text-gray-600">
                  {item.content}
                </div>
              </div>
            ))}
          </div>
          
          <div className="flex flex-col lg:flex-row bg-white shadow-xl rounded-lg overflow-hidden">
            <div className="lg:w-1/2 p-8 lg:p-12">
              <h2 className="text-3xl font-bold text-gray-800 mb-6">Send Us A Message</h2>
              <p className="text-gray-600 mb-8">
                Have a question or want to work together? Fill out the form and we'll get back to you as soon as possible.
              </p>
              
              <ContactForm />
            </div>
            
            <div className="lg:w-1/2 bg-gray-100">
              <LocationMap />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;